import { createSlice } from '@reduxjs/toolkit'

export const slice = createSlice({
  name: 'dashboard',
  initialState: {
    showOnboarding: null,
    onboardingStep: 1,
    settingsOpened: false,
    isLayoutEdit: false,
    onboardingHintsCompleted: false,
  },
  reducers: {
    setShowOnboarding: (state, action) => {
      state.showOnboarding = action.payload;
    },
    nextStep: state => {
      state.onboardingStep++;
    },
    prevStep: state => {
      state.onboardingStep--;
    },
    setStep: (state, action) => {
      state.onboardingStep = action.payload
    },
    toggleSettingsOpened: (state, action) => {
      state.settingsOpened = Boolean(action.payload);
    },
    setLayoutEdit: (state, action) => {
      state.isLayoutEdit = Boolean(action.payload);
    },
    setOnboardingHintsCompleted: (state, action) => {
      state.onboardingHintsCompleted = action.payload;
    }
  }
});

export const {
  setLayoutEdit,
  setShowOnboarding,
  setOnboardingHintsCompleted,
  nextStep,
  prevStep,
  setStep,
  toggleSettingsOpened,
} = slice.actions;

export const selectShowonboarding = state => state.dashboard.showOnboarding;
export const selectOnboardingStep = state => state.dashboard.onboardingStep;
export const selectSettingsOpened = state => state.dashboard.settingsOpened;
export const selectIsLayoutEdit = state => state.dashboard.isLayoutEdit;
export const selectOnboardingHintsCompleted = state => state.dashboard.onboardingHintsCompleted;

export default slice.reducer;
